import { Flex, Input, Label } from 'theme-ui';
import React from 'react';

const DeliveryWindowEditor = ({ startTime, endTime, onAdjustment }) => {
  const determineIfEndTimeIsNextDay = (startTime, endTime) => {
    const [startHour, startMinute] = startTime.split(':');
    const [endHour, endMinute] = endTime.split(':');

    const startDate = new Date();
    const endDate = new Date();

    startDate.setHours(Number(startHour), Number(startMinute), 0);
    endDate.setHours(Number(endHour), Number(endMinute), 0);

    return startDate > endDate ? '(+1 day)' : '';
  };

  const handleStartTimeChange = (e) => {
    const newStartTime = e.target.value;
    onAdjustment(newStartTime, endTime);
  };

  const handleEndTimeChange = (e) => {
    const newEndTime = e.target.value;
    onAdjustment(startTime, newEndTime);
  };

  return (
    <Flex sx={{ gap: 3 }}>
      <Label
        sx={{
          flex: 1,
          alignItems: 'center',
          paddingRight: '1rem',
          justifyContent: 'start',
        }}
      >
        Start time
      </Label>
      <Input
        sx={{ flex: 1 }}
        type="time"
        value={startTime}
        onChange={handleStartTimeChange}
      />
      <Label
        sx={{
          flex: 1,
          alignItems: 'center',
          paddingRight: '1rem',
          justifyContent: 'center',
        }}
      >
        End time {determineIfEndTimeIsNextDay(startTime, endTime)}
      </Label>
      <Input
        sx={{ flex: 1 }}
        type="time"
        value={endTime}
        onChange={handleEndTimeChange}
      />
    </Flex>
  );
};

export default DeliveryWindowEditor;
